import React from "react";
import PropTypes from 'prop-types';


const SearchBookForm = ({ handleSearch, title, setTitle, author, setAuthor }) => {
    return (
        <form onKeyDown={handleSearch}>
            <input
                type="text"
                id="search"
                name="search"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Search book"
                className="w-full max-w-md px-4 py-2 mt-5 ml-5 border border-warm-200 rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-warm-400 focus:border-transparent bg-warm-50 text-warm-800"
            />
            <input
                type="text"
                id="author"
                name="author"
                value={author}
                onChange={(e) => setAuthor(e.target.value)}
                placeholder="Author name"
                className="w-full max-w-md px-4 py-2 mt-5 ml-5 border border-warm-200 rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-warm-400 focus:border-transparent bg-warm-50 text-warm-800"
            />
        </form>
    );
}

SearchBookForm.propTypes = {
    handleSearch: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    setTitle: PropTypes.func.isRequired,
    author: PropTypes.string.isRequired,
    setAuthor: PropTypes.func.isRequired,
};

export default SearchBookForm;